import { useApi } from '@/composables/use-api'
import type {
  IThreadsListResponse,
  ICreateThreadRequest,
  ICreateThreadResponse,
  ISidebarThreadsResponse,
  TThreadsSearchResponse,
  TThreadCategoriesResponse,
  IThreadResponse,
  IThreadListRequestQuery,
  TThreadPeriod,
  IThreadAgentsResponse,
  ISwitchThreadAgentRequest,
} from './types'

export const ThreadsApi = {
  searchThreads(search: string, page = 1, limit = 20) {
    const url = `/search?search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`
    return useApi().get<TThreadsSearchResponse>(url)
  },

  getThreads(params: Partial<IThreadListRequestQuery>) {
    const url = `/threads`
    return useApi().get<IThreadsListResponse>(url, { params: { limit: 8, ...params } })
  },

  getThreadInfo(threadId: string) {
    const url = `/threads/${threadId.toString()}`
    return useApi().get<IThreadResponse>(url)
  },

  createThread(data: ICreateThreadRequest) {
    const url = '/threads'
    return useApi().post<ICreateThreadResponse>(url, data)
  },

  getSidebarThreads(modified_at?: string, limit = 10, period?: TThreadPeriod) {
    const params = new URLSearchParams({
      limit: limit.toString(),
    })

    if (modified_at) params.append('modified_at', modified_at)
    if (period) params.append('period', period)

    const url = `/threads/sidebar?${params.toString()}`
    return useApi().get<ISidebarThreadsResponse>(url)
  },

  getSidebarThreadsNext(params: string) {
    const url = `/threads/sidebar${params.toString()}`
    return useApi().get<ISidebarThreadsResponse>(url)
  },

  getThreadCategories() {
    const url = '/threads/categories'
    return useApi().get<TThreadCategoriesResponse>(url)
  },

  deleteThread(thread_id: string) {
    const url = `/threads/${thread_id}`
    return useApi().delete(url)
  },

  getThreadAgents(threadId: string) {
    const url = `/threads/${threadId}/agents`
    return useApi().get<IThreadAgentsResponse>(url)
  },

  switchThreadAgent(threadId: string, data: ISwitchThreadAgentRequest) {
    const url = `/threads/${threadId}/agent`
    return useApi().patch(url, data)
  },
}
